import { render, staticRenderFns } from "./Overlay.vue?vue&type=template&id=c0a3214e&scoped=true"
import script from "./Overlay.vue?vue&type=script&lang=js"
export * from "./Overlay.vue?vue&type=script&lang=js"
import style0 from "./Overlay.vue?vue&type=style&index=0&id=c0a3214e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0a3214e",
  null
  
)

export default component.exports